// extracted by mini-css-extract-plugin
export default {"root":"ValueSaveOptionsDialog_root__W98Rl","placeHolderShimmer":"ValueSaveOptionsDialog_placeHolderShimmer__1Rozb"};